import { Check, X } from "lucide-react";

export type PwRule = { key: string; label: string; test: (s: string) => boolean };

export const PW_RULES: PwRule[] = [
  { key: "len", label: "Mindestens 8 Zeichen", test: (s) => s.length >= 8 },
  { key: "upper", label: "1 Großbuchstabe (A–Z)", test: (s) => /[A-Z]/.test(s) },
  { key: "lower", label: "1 Kleinbuchstabe (a–z)", test: (s) => /[a-z]/.test(s) },
  { key: "digit", label: "1 Zahl (0–9)", test: (s) => /\d/.test(s) },
  { key: "special", label: "1 Sonderzeichen (!@#$…)", test: (s) => /[^A-Za-z0-9]/.test(s) },
];

export function validatePassword(pw: string) {
  const failed = PW_RULES.filter((r) => !r.test(pw)).map((r) => r.key);
  return { ok: failed.length === 0, failed };
}

export function PasswordRequirements({ password }: { password: string }) {
  return (
    <ul className="rounded-md border border-border bg-muted/40 p-3 space-y-1.5 text-xs">
      {PW_RULES.map((r) => {
        const ok = r.test(password);
        return (
          <li key={r.key} className={`flex items-center gap-2 ${ok ? "text-success" : "text-muted-foreground"}`}>
            {ok ? <Check className="h-3.5 w-3.5" /> : <X className="h-3.5 w-3.5 opacity-50" />}
            <span className={ok ? "font-semibold" : ""}>{r.label}</span>
          </li>
        );
      })}
    </ul>
  );
}
